import Immutable from "immutable";

import * as common from "lib/appserver/entityHeaders/common";

export const Parent = new Immutable.Record({
  ...common.defaultProperties,
  firstName: undefined,
  lastName: undefined,
  emailAddress: undefined
}, "Parent");

function buildParentFromAppserver(rawParent) {
  // special case for parents since they are their own linked entity
  rawParent.id = rawParent.appserver_remote_entity_id;
  return Parent({
    ...common.appserverAdapter(rawParent),
    firstName: rawParent.parent.first_name,
    lastName: rawParent.parent.last_name,
    emailAddress: rawParent.parent.email_address
  });
}

Parent.fromAppserver = buildParentFromAppserver;
export default Parent;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/Parent.js